<template>
  <div
    v-click-outside="$_closeSubBtnList"
    class="lv-btn"
  >
    <div
      class="mr-8 mb-8 lv-btn-list__btn rectangle ellipsis"
      :class="{active: $_isActive(btn), white, 'alice-blue': aliceBlue, 'flex-col-under-md': flexColUnderMd, big}"
      @click="$_onClickBtn(btn)"
    ><p class="lv-btn-list__btn-text" :class="{big}">{{ $t(btn.text) }}</p></div>
    <div
      v-if="btn.subList && isActive.subList"
      class="lv-btn-list__sub-btn-wrap"
      :class="{active: isActive.subList}"
    >
      <div
        v-for="(subBtn, subBtnIndex) in btn.subList"
        :key="`subBtn_${subBtnIndex}`"
        class="mr-8 mb-8 lv-btn-list__btn rectangle ellipsis"
        :class="{active: $_isActive(subBtn), white, 'alice-blue': aliceBlue, big}"
        @click="$_onClickBtn(subBtn)"
      ><p class="lv-btn-list__btn-text" :class="{big}">{{ $t(subBtn.text) }}</p></div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  directives: {
    ClickOutside,
  },
  props: {
    value: {
      type: [String, Number],
    },
    btn: {
      type: Object,
    },
    aliceBlue: {
      type: Boolean,
      default: true,
    },
    white: {
      type: Boolean,
      default: false,
    },
    flexColUnderMd: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isActive: {
        subList: false,
      },
      selectedBtn: {},
    }
  },
  methods: {
    $_onClickBtn(btn) {
      if (btn.subList && btn.subList.length) {
        this.$_toggleSubBtnList();
      } else {
        this.$emit('click', btn.id);
        this.$_closeSubBtnList('$_onClickBtn');
      }
    },
    $_onClickSubBtn(btn) {
      this.$emit('click', btn.id);
    },
    $_isActive(btn) {
      if (btn.subList) {
        const tarIndex = btn.subList.findIndex(btn => btn.id == this.value);
        return tarIndex > -1;
      } else {
        return btn.id == this.value;
      }
    },
    $_toggleSubBtnList(){
      this.isActive.subList = !this.isActive.subList;
    },
    $_closeSubBtnList() {
      if (!this.isActive.subList) return;
      this.isActive.subList = false;
    },
  }
}
</script>